var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.visible
    ? _c(
        "OverlayBackdrop",
        {
          attrs: {
            portalOrder: _vm.portalOrder,
            fullPage: _vm.fullPage,
            loadedFilters: _vm.loadedFilters
          },
          on: { click: _vm.onOverlayClick }
        },
        [
          _vm.visible
            ? _c(
                _vm.htmlTag,
                { tag: "component", class: ["modal", ..._vm.variantClassList] },
                [
                  _c("header", { staticClass: "modal__header" }, [
                    _c("div", { staticClass: "modal__content-container" }, [
                      _c("h2", { staticClass: "modal__title" }, [
                        _vm._v(" " + _vm._s(_vm.title) + " ")
                      ]),
                      _vm.$slots.header
                        ? _c(
                            "p",
                            { staticClass: "modal__description" },
                            [
                              _vm._t("header", function() {
                                return [_vm._v(_vm._s(_vm.description))]
                              })
                            ],
                            2
                          )
                        : _vm._e()
                    ]),
                    _vm.hasCloseBtn
                      ? _c(
                          "span",
                          { staticClass: "modal__close-btn" },
                          [
                            _c("ButtonIcon", {
                              attrs: {
                                iconClassName: "icon-remove-2",
                                "data-testid": "close-btn"
                              },
                              on: { click: _vm.onClose }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ]),
                  _c(
                    "div",
                    {
                      staticClass: "modal__body",
                      attrs: { "data-testid": "modalBody" }
                    },
                    [
                      _vm.hasBodyToolbar
                        ? _c(
                            "div",
                            { staticClass: "modal__body-toolbar" },
                            [_vm._t("bodyToolbar")],
                            2
                          )
                        : _vm._e(),
                      _vm._t("body")
                    ],
                    2
                  ),
                  _vm.showApply || _vm.$slots.footer !== undefined
                    ? _c(
                        "footer",
                        { staticClass: "modal__footer" },
                        [
                          _vm._t("footer", function() {
                            return [
                              _vm.showApply
                                ? _c(
                                    "ButtonSet",
                                    { attrs: { "data-testid": "set-btn" } },
                                    [
                                      _c("ButtonClassic", {
                                        attrs: {
                                          variant: "primary",
                                          labelText: _vm.applyLabelText,
                                          "data-testid": "save-btn",
                                          stopPropagation: true
                                        },
                                        on: { click: _vm.onApply }
                                      }),
                                      _c("ButtonClassic", {
                                        attrs: {
                                          variant: "text",
                                          labelText: _vm.closeLabelText,
                                          "data-testid": "btn-close",
                                          stopPropagation: true
                                        },
                                        on: { click: _vm.onCancel }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ]
                          })
                        ],
                        2
                      )
                    : _vm._e()
                ]
              )
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }